import { seoName } from 'core-utilities';
import { EnvironmentUrls } from 'Roblox';
import itemCardConstants from '../constants/itemCardConstants';
import urlConfigs from '../constants/urlConfigs';
import { TCatalog } from '../containers/AvatarShopHomepageRecommendationsCarouselTypes';

export const getItemLink = (itemId: number, itemName: string, itemType: string): string => {
  let urlType = urlConfigs.assetRootUrlTemplate;
  if (itemType === 'CatalogBundle') {
    urlType = urlConfigs.bundleRootUrlTemplate;
  }
  return `${EnvironmentUrls.websiteUrl}/${urlType}/${itemId}/${seoName.formatSeoName(itemName)}`;
};

export const getProfileLink = (
  creatorId: number,
  creatorType: string,
  creatorName: string
): string => {
  if (creatorType === 'Group') {
    return `${EnvironmentUrls.websiteUrl}/groups/${creatorId}/${creatorName}`;
  }
  return `${EnvironmentUrls.websiteUrl}/users/${creatorId}/profile`;
};

export type TItemCardRestrictions = {
  isLimited: boolean;
  isRthro: boolean;
  isThirteenPlus: boolean;
  isLimitedUnique: boolean;
  itemRestrictionIcon: string;
};

export const mapItemRestrictionIcons = (item: TCatalog): TItemCardRestrictions => {
  const itemRestrictions: TItemCardRestrictions = {
    isLimited: false,
    isRthro: false,
    isThirteenPlus: false,
    isLimitedUnique: false,
    itemRestrictionIcon: ''
  };
  if (item && item.itemRestrictions) {
    const { itemTypes, itemRestrictionTypes, itemRestrictionIcons } = itemCardConstants;
    if (item.itemType === itemTypes.bundle) {
      itemRestrictions.isLimited = item.itemRestrictions.indexOf(itemRestrictionTypes.limited) > -1;
      itemRestrictions.isRthro = item.itemRestrictions.indexOf(itemRestrictionTypes.rthro) > -1;
      if (itemRestrictions.isLimited) {
        itemRestrictions.itemRestrictionIcon = itemRestrictions.isRthro
          ? itemRestrictionIcons.rthroLimitedLabel
          : itemRestrictionIcons.limited;
      } else if (itemRestrictions.isRthro) {
        itemRestrictions.itemRestrictionIcon = itemRestrictionIcons.rthroLabel;
      }
    } else {
      itemRestrictions.isThirteenPlus =
        item.itemRestrictions.indexOf(itemRestrictionTypes.thirteenPlus) > -1;
      itemRestrictions.isLimitedUnique =
        item.itemRestrictions.indexOf(itemRestrictionTypes.limitedUnique) > -1;
      itemRestrictions.isLimited = item.itemRestrictions.indexOf(itemRestrictionTypes.limited) > -1;
      if (itemRestrictions.isLimitedUnique) {
        itemRestrictions.itemRestrictionIcon = itemRestrictions.isThirteenPlus
          ? itemRestrictionIcons.thirteenPlusLimitedUnique
          : itemRestrictionIcons.limitedUnique;
      } else if (itemRestrictions.isLimited) {
        itemRestrictions.itemRestrictionIcon = itemRestrictions.isThirteenPlus
          ? itemRestrictionIcons.thirteenPlusLimited
          : itemRestrictionIcons.limited;
      } else if (itemRestrictions.isThirteenPlus) {
        itemRestrictions.itemRestrictionIcon = itemRestrictionIcons.thirteenPlus;
      }
    }
  }
  return itemRestrictions;
};

export type TItemStatus = {
  isIcon: boolean;
  type: string;
  class: string;
  label: string;
};

export const mapItemStatusIconsAndLabels = (item: TCatalog): Array<TItemStatus> => {
  const itemStatuses: TItemStatus[] = [];
  if (item && item.itemStatus) {
    const {
      itemStatusClasses,
      itemStatusIcons,
      itemStatusLabels,
      itemStatusTypes
    } = itemCardConstants;
    if (item.itemStatus.indexOf(itemStatusTypes.SaleTimer) > -1) {
      itemStatuses.push({
        isIcon: true,
        type: itemStatusIcons.SaleTimer,
        class: '',
        label: ''
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.New) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.New,
        label: itemStatusLabels.New
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.Sale) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.Sale,
        label: itemStatusLabels.Sale
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.XboxExclusive) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.XboxExclusive,
        label: itemStatusLabels.XboxExclusive
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.AmazonExclusive) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.AmazonExclusive,
        label: itemStatusLabels.AmazonExclusive
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.GooglePlayExclusive) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.GooglePlayExclusive,
        label: itemStatusLabels.GooglePlayExclusive
      });
    }
    if (item.itemStatus.indexOf(itemStatusTypes.IosExclusive) > -1) {
      itemStatuses.push({
        isIcon: false,
        type: '',
        class: itemStatusClasses.IosExclusive,
        label: itemStatusLabels.IosExclusive
      });
    }
  }
  return itemStatuses;
};

export default {
  getItemLink,
  getProfileLink,
  mapItemRestrictionIcons,
  mapItemStatusIconsAndLabels
};
